var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.290668 0.814314C0.092218 1.01276 0.092218 1.33524 0.290668 1.53369L6.62865 7.85928L0.290668 14.1973C0.0922186 14.3957 0.0922186 14.7182 0.290668 14.9166C0.489118 15.1151 0.811599 15.1151 1.01005 14.9166L7.69532 8.23137C7.79454 8.13214 7.84416 8.00811 7.84416 7.87168C7.84416 7.74765 7.79454 7.61121 7.69532 7.51199L1.01005 0.826718C0.811598 0.615865 0.489117 0.615864 0.290668 0.814314Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.d49f13d6b0751af47c78af2ad11eaacc.svg";
export { ForwardRef as ReactComponent };